import React from "react";
import PropTypes from "prop-types";

import Select from "../../../common/controls/Select";
import Label from "../../../common/controls/Label";

export default class RecordSourceSelection extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedKey: props.options[0].value, // always select the first item
        };
        this.onCommitChange = this.onCommitChange.bind(this);
    }

    onCommitChange(value) {
        const {onChange} = this.props;
        this.setState({selectedKey: value});
        onChange(value);
    }

    render() {
        const { options } = this.props;
        if (options.length === 1) {
            const activeLabel = options[0].label;
            return (<Label id="source-type" label="Source:" value={activeLabel} controlOnly={false} />);
        } else {
            return (<Select id="source-type" label="Source:" onCommitChange={this.onCommitChange} options={options} value={this.state.selectedKey} controlOnly={false} />);
        }
    }

}

RecordSourceSelection.propTypes = {
    onChange: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired
};



// WEBPACK FOOTER //
// ./app/lib/mapping/views/recordsourcepluginview/RecordSourceSelection.js